function toNum(o) { return o ? "number" == typeof o ? o : o.indexOf(".") > -1 ? Number.parseFloat(o) : Number.parseInt(o) : 0; }
function toBool(o) { return !0 === o || !1 === o ? o : "" === o || "true" === o; }
function commas(o) { return o.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
export { commas as a, toNum as b, toBool as c };
